import React from "react"
import { useIntl } from "gatsby-plugin-intl"
import greenBadge from "../images/badge-green.png"
import redBadge from "../images/badge-red.png"
import blueBadge from "../images/badge-blue.png"

const ModuleBadge = props => {
  const intl = useIntl()
  let colorBadge
  let colorLabel
  let label
  switch (props.module) {
    case "O4":
      colorBadge = greenBadge
      colorLabel = "#99F0DE"
      label = intl.formatMessage({ id: "training2" })
      break
    case "O5":
      colorBadge = redBadge
      colorLabel = "#FFD4D7"
      label = intl.formatMessage({ id: "training3" })
      break
    case "O6":
      colorBadge = blueBadge
      colorLabel = "#C7B7FD"
      label = intl.formatMessage({ id: "training4" })
      break

    default:
  }

  let badgeStyle = {}
  if (props.source === "lessonBanner" && props.module === "O6") {
    badgeStyle = { color: "#FFF" }
  }
  return (
    <div className="badge" style={{ backgroundImage: `url(${colorBadge})` }}>
      <div className="badge__content">
        <div className="badge__content__hundredsPoints" style={badgeStyle}>
          <div>100</div>
          <div>{intl.formatMessage({ id: "training0" })}</div>
        </div>
        <div
          className="badge__content__label"
          style={{ backgroundColor: `${colorLabel}` }}
        >
          {label}
        </div>
      </div>
    </div>
  )
}
export default ModuleBadge
